<template>
    <CodiceFeanorView tool-module="transform" />
</template>

<script setup>
import CodiceFeanorView from "../CodiceFeanorView.vue";
</script>
